import React, { useEffect, useState, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import DashboardWrapper from "../../components/DashboardWrapper";
import orderService from "../../services/orderService";
import Loader from "../../components/Loader";
import Swal from "sweetalert2";
import Breadcrumb from "../../components/Breadcrumbdashboard";
import authService from "../../services/authService";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
export default function DisplayParticularOrderDetails() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  const invoiceRef = useRef(null);
const currentUser = authService.getCurrentUser();

const userRoleSlug = currentUser?.role?.slug;

const hideOrderStatuses = [
  "tele-caller",
  "account-manager",
].includes(userRoleSlug);
  const orderStatusOptions = ["pending", "processing", "shipped", "delivered", "cancelled"];
  const paymentStatusOptions = ["pending", "paid", "failed", "refunded"];

  const handleStatusChange = async (field, value) => {
  const result = await Swal.fire({
      title: "Are you sure?",
      text: `Change ${field.replace("_", " ")} to "${value}"?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, update it!",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#FB6C22",
    });

    if (!result.isConfirmed) return;

    try {
      await orderService.updateStatus(order.id, { [field]: value });
      setOrder((prev) => ({ ...prev, [field]: value }));
      Swal.fire({
        title: "Success",
        text: "Status updated successfully!",
        icon: "success",
        confirmButtonText: "OK",
        confirmButtonColor: "#FB6C22",
      });

    } catch (error) {
      Swal.fire("Error!", "Failed to update status.", "error");
    }
  };

  const fetchOrderDetails = async () => {
    try {
      const response = await orderService.getOrderById(id);
      setOrder({
        ...response.data.order,
        order_products: response.data.order.order_products || [],
      });
    } catch (error) {
      console.error("Error fetching order details:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrderDetails();
  }, [id]);

 const handleDownloadPDF = () => {
  if (!order) return;

  const doc = new jsPDF("p", "mm", "a4");

  // =========================
  // Invoice Header
  // =========================

  doc.setFont("helvetica", "bold");
  doc.setFontSize(20);
  doc.text("VITAURA", 20, 20);

  doc.setFontSize(16);
  doc.text("INVOICE", 20, 32);

  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);

  doc.text(`Invoice ID: ${order.invoice_id || "N/A"}`, 20, 42);
  doc.text(
    `Date: ${
      order.created_at
        ? new Date(order.created_at).toLocaleDateString("en-IN")
        : "N/A"
    }`,
    20,
    49
  );

  doc.text(
    `Status: ${String(order.order_status || "N/A").toUpperCase()}`,
    20,
    56
  );

  // =========================
  // From
  // =========================

  doc.setFont("helvetica", "bold");
  doc.text("From:", 130, 32);

  doc.setFont("helvetica", "normal");
  doc.text("VITAURA", 130, 39);
  doc.text("Kompally, Hyderabad", 130, 46);
  doc.text("info@vitaura.co.in", 130, 53);
  doc.text("+91 8019070584", 130, 60);

  // =========================
  // Bill To
  // =========================

  doc.setFont("helvetica", "bold");
  doc.text("Bill To:", 20, 75);

  doc.setFont("helvetica", "normal");

  doc.text(
    String(order.user?.username || "N/A"),
    20,
    82
  );

  doc.text(
    String(order.user?.email || "N/A"),
    20,
    89
  );

  doc.text(
    String(order.user?.phone_number || "N/A"),
    20,
    96
  );

  // =========================
  // Ship To
  // =========================

  doc.setFont("helvetica", "bold");
  doc.text("Ship To:", 120, 75);

  doc.setFont("helvetica", "normal");

  const address = order.order_address || {};

  doc.text(
    String(getValue(address.name)),
    120,
    82
  );

  doc.text(
    String(getValue(address.address)),
    120,
    89
  );

  doc.text(
    `${getValue(address.city)}, ${getValue(address.state)} - ${getValue(
      address.zip
    )}`,
    120,
    96
  );

  doc.text(
    String(getValue(address.country)),
    120,
    103
  );

  doc.text(
    String(getValue(address.phone)),
    120,
    110
  );

  // =========================
  // Order Items
  // =========================

  const tableData = order.order_products.map((item) => [
    item.product_name || "N/A",
    `Rs. ${Number(item.unit_price || 0).toFixed(2)}`,
    item.qty || 0,
    item.product?.sku || "N/A",
    `Rs. ${(
      Number(item.unit_price || 0) * Number(item.qty || 0)
    ).toFixed(2)}`,
  ]);

  autoTable(doc, {
    startY: 120,
    head: [
      ["Product", "Unit Price", "Qty", "SKU", "Total"],
    ],
    body: tableData,

    theme: "grid",

    styles: {
      fontSize: 9,
      cellPadding: 3,
    },

    headStyles: {
      fontStyle: "bold",
    },

    columnStyles: {
      0: { cellWidth: 55 },
      1: { cellWidth: 30 },
      2: { cellWidth: 15 },
      3: { cellWidth: 30 },
      4: { cellWidth: 35 },
    },
  });

  // =========================
  // Totals
  // =========================

  const finalY =
    doc.lastAutoTable.finalY + 10;

  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);

  doc.text(
    `Subtotal: Rs. ${Number(order.sub_total || 0).toFixed(2)}`,
    130,
    finalY
  );

  doc.text(
    `Shipping: Rs. ${Number(
      order.shipping_method?.cost || 0
    ).toFixed(2)}`,
    130,
    finalY + 7
  );

  doc.text(
    `Payment Method: ${String(
      getValue(order.payment_method)
    ).toUpperCase()}`,
    130,
    finalY + 14
  );

  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);

  doc.text(
    `Grand Total: Rs. ${Number(order.amount || 0).toFixed(2)}`,
    130,
    finalY + 24
  );

  // =========================
  // Footer
  // =========================

  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);

  doc.text(
    "Thank you for shopping with us!",
    105,
    finalY + 42,
    { align: "center" }
  );

  doc.text(
    "For support: info@vitaura.co.in",
    105,
    finalY + 49,
    { align: "center" }
  );

  // =========================
  // Download PDF
  // =========================

  doc.save(`Invoice-${order.invoice_id || order.id}.pdf`);
};
const getValue = (value) => {
  if (value === null || value === undefined) return "N/A";

  if (typeof value === "object") {
    return value.name || value.label || value.title || "N/A";
  }

  return value;
};
  return (
    <DashboardWrapper>
      <div className="container my-5">
        {loading && <Loader minHeight={200} />}

        {!loading && order && (
          <div>
            {/* Header */}
            <div className="d-flex justify-content-between align-items-center mb-4 no-print">
           <Breadcrumb/>

              <div>
                <button onClick={handleDownloadPDF} className="btn btn-success me-3">
                  Download PDF
                </button>
                <button onClick={() => window.print()} className="btn btn-outline-secondary">
                  Print
                </button>
              </div>
            </div>

            {/* Invoice */}
            <div ref={invoiceRef} className="invoice border rounded shadow p-4 bg-white">
              <div className="d-flex justify-content-between align-items-start">
                <div>
                  <h2 className="fw-bold">INVOICE</h2>
                  <p className="text-muted mb-1">
                    Invoice ID: <strong>{order.invoice_id}</strong>
                  </p>
                  <p className="text-muted mb-1">
                    Status: <strong className="text-primary text-capitalize">{order.order_status}</strong>
                  </p>
                  <p className="text-muted">
                    Date: {new Date(order.created_at).toLocaleDateString("en-IN")}
                  </p>
                </div>

                <div className="text-end">
                  <h5 className="fw-bold">From:</h5>
                  <p className="text-muted mb-1">VITAURA</p>
                  <p className="text-muted mb-1">Kompally ,  Hyderabad</p>
                  <p className="text-muted mb-1"> info@vitaura.co.in</p>
                  <p className="text-muted mb-1">+91 8019070584</p>
                </div>
              </div>

              <hr />

              <div className="row mt-4">
                <div className="col-md-6">
                  <h5 className="fw-bold">Bill To:</h5>
                  <p className="text-muted mb-1">{order.user?.username}</p>
                  <p className="text-muted mb-1">{order.user?.email}</p>
                  <p className="text-muted mb-1">{order.user?.phone_number}</p>
                </div>

              <div className="col-md-6 text-md-end">
  <h5 className="fw-bold">Ship To:</h5>

  <p className="text-muted mb-1">
    {getValue(order.order_address?.name)}
  </p>

  <p className="text-muted mb-1">
    {getValue(order.order_address?.address)}
  </p>

  <p className="text-muted mb-1">
    {getValue(order.order_address?.city)},{" "}
    {getValue(order.order_address?.state)} -{" "}
    {getValue(order.order_address?.zip)}
  </p>

  <p className="text-muted mb-1">
    {getValue(order.order_address?.country)}
  </p>

  <p className="text-muted mb-1">
    {getValue(order.order_address?.phone)}
  </p>
</div>
              </div>

              <hr />

              <h5 className="fw-bold mt-4">Order Items</h5>
              <div className="table-responsive">
              <table className="table table-striped mt-3">
                <thead className="table-dark">
                  <tr>
                    <th>Product</th>
                    <th>Unit Price</th>
                    <th>Qty</th>
                    <th>Sku</th>
                    <th>Total</th>
                  </tr>
                </thead>
                <tbody>
                  {order.order_products.map((item) => (
                    <tr key={item.id}>
                      <td>{item.product_name}</td>
                      <td>₹ {parseFloat(item.unit_price).toFixed(2)}</td>
                      <td>{item.qty}</td>
                      <td>{item.product?.sku}</td>
                      <td>₹ {(item.unit_price * item.qty).toFixed(2)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              </div>

              {/* Status Dropdowns (UI UNCHANGED) */}
          {/* Status Dropdowns */}
<div className="row mt-4">

  {/* Hide Order Status & Payment Status for Telecaller and Account Manager */}
  {!hideOrderStatuses && (
    <div className="col-md-7 no-print">
      <label className="fw-bold">Order Status</label>

      <select
        className="form-select mb-3"
        value={order.order_status}
        onChange={(e) =>
          handleStatusChange("order_status", e.target.value)
        }
      >
        {orderStatusOptions.map((st) => (
          <option key={st} value={st}>
            {st.charAt(0).toUpperCase() + st.slice(1)}
          </option>
        ))}
      </select>

      <label className="fw-bold">Payment Status</label>

      <select
        className="form-select"
        value={order.payment_status}
        onChange={(e) =>
          handleStatusChange("payment_status", e.target.value)
        }
      >
        {paymentStatusOptions.map((st) => (
          <option key={st} value={st}>
            {st.charAt(0).toUpperCase() + st.slice(1)}
          </option>
        ))}
      </select>
    </div>
  )}

<div className={hideOrderStatuses ? "col-md-5 ms-auto" : "col-md-5"}>
                  <table className="table table-borderless">
                    <tbody>
                      <tr>
                        <th>Subtotal:</th>
                        <td className="text-end">₹ {parseFloat(order.sub_total).toFixed(2)}</td>
                      </tr>
                      <tr>
                        <th>Shipping:</th>
                        <td className="text-end">
                          ₹ {parseFloat(order.shipping_method?.cost || 0).toFixed(2)}
                        </td>
                      </tr>
                      <tr>
                        <th>Payment Method:</th>
                      <td className="text-end">
  {String(getValue(order.payment_method)).toUpperCase()}
</td>
                      </tr>
                      <tr className="fw-bold fs-5">
                        <th>Grand Total:</th>
                        <td className="text-end">
                          ₹ {(Number(order.amount)).toFixed(2)}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="text-center mt-5">
                <p className="text-muted">Thank you for shopping with us!</p>
                <small>For support : {" "}
                <a
                                href="mailto:info@vitaura.co.in"
                               style={{color:"#FB6C22"}}
                              >
                                info@vitaura.co.in
                              </a>

                </small>
              </div>
            </div>
          </div>
        )}
      </div>

      <style jsx>{`
        @media print {
          body * {
            visibility: hidden;
          }

          .invoice,
          .invoice * {
            visibility: visible;
          }

          .invoice {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
          }

          .no-print,
          .no-print * {
            display: none !important;
          }
        }
      `}</style>
    </DashboardWrapper>
  );
}
